<template>
  <div class="default-modal">
    <el-dialog
      @close="close"
      width="45%"
      top="15vh"
      v-model="exportDialogVisisble"
      title="Mileage Cases Report"
    >
      <div v-loading="exportCases">
        <div class="export-dialog-header">
          <div class="export-header-part"><h3>MILEAGE CASES REPORT</h3></div>

          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="close"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="export-include-select-field">
          <h4 class="check-all-sub-title">DATA INCLUDES :</h4>

          <el-checkbox
            class="search-checkbox"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >Check All</el-checkbox
          >
        </div>
        <div class="dialog-body">
          <div class="export-popup-body mt-0" v-loading="loading">
            <el-checkbox-group v-model="activeFieldList" @change="isCheckAll">
              <el-row>
                <el-col :span="24">
                  <ul class="select-fields-list">
                    <li
                      class="search-checkbox"
                      v-for="(item, index) in exportMileageExcelFields"
                      :key="index"
                    >
                      <el-checkbox :label="item.value">{{
                        item.label
                      }}</el-checkbox>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </div>
        </div>
        <div class="dialog-footer export-footer w-95">
          <el-button class="cancel-button" @click="close">CANCEL</el-button>
          <el-button class="blue-save-button" @click="downloadCases()">
            DOWNLOAD
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import exportExcelHelper from "@/mixins/exportExcelHelper";

import FilterHelper from "@/mixins/FilterHelper";
import { mapGetters } from "vuex";
import moment from "moment";

import caseConstants from "@/config/constants/caseConstants";
export default {
  mixins: [
    UserPermissionsHelper,
    exportExcelHelper,
    caseDataHelper,
    AppHelper,
    FilterHelper,
  ],

  computed: {
    getCaseTypeMap() {
      return (status) => this.caseTypeMap[status];
    },
    getStatusMap() {
      return (status) => {
        return (status || []).map((e) => this.statusMap[e]);
      };
    },
  },
  data() {
    return {
      exportCases: false,
      exportDialogVisisble: true,
      fieldList: [],
      activeFieldList: [],
      checkAll: true,
      loading: false,
      date_type: "collection_date",
      status: "",
      statusMap: caseConstants.STATUS_TYPE_MAP,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  mounted() {
    this.loadFieldsList();
    this.status = this.search_case_status;
  },
  methods: {
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportMileageExcelFields &&
        this.activeFieldList.length &&
        this.exportMileageExcelFields.length &&
        this.activeFieldList.length == this.exportMileageExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    async downloadCases() {
      try {
        this.exportCases = true;
        if (this.activeFieldList.length) {
          let params = {
            include: this.activeFieldList,
          };

          await this.$store.dispatch("cases/downloadMileageCasesData", params);
          this.exportCases = false;
          this.close();
        } else {
          this.$message({
            message: "Please select the data fields.",
            type: "warning",
          });
        }
      } catch (err) {
        this.exportCases = false;
        console.log(err);
      }
    },
    loadFieldsList() {
      this.exportMileageExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },

    close() {
      this.$emit("close");
    },
    handleCheckAllChange(val) {
      this.activeFieldList = val ? this.fieldList : [];
    },
  },
};
</script>
